import { pushToDataLayer } from '@app/infrastructure/gtm/pushToDataLayer';
import { GtmEventName } from '@app/domain/model/gtm/GtmEventName';
import { GtmInsuranceType } from '@app/domain/model/gtm/GtmInsuranceType';
import { StartCalculationData } from '@app/domain/model/gtm/StartCalculationData';

export function trackStartCalculation(data: StartCalculationData): void {
    pushToDataLayer(GtmEventName.StartCalculation, {
        insurance_type: GtmInsuranceType.Transport,
        licence_plate: data.licencePlate,
        is_company: data.isCompany,
    });
}
